import { useAuth } from '@/auth/useAuth';
import { Button, Icon } from '@/components/ui';

export function AccessDenied() {
  const { logout } = useAuth();
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 24,
        textAlign: 'center',
      }}
    >
      <Icon name="shield" size={36} style={{ color: 'var(--text-3)' }} />
      <h1 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>Access denied</h1>
      <p style={{ margin: 0, maxWidth: 380, color: 'var(--text-2)', fontSize: 13.5, lineHeight: 1.5 }}>
        You do not have permission to access this application. Please ask an administrator to set
        up your access roles, then sign in again.
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        <Button
          variant="secondary"
          leftIcon={<Icon name="refresh" size={14} />}
          onClick={() => window.location.reload()}
        >
          Try again
        </Button>
        <Button variant="secondary" leftIcon={<Icon name="logout" size={14} />} onClick={() => void logout()}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
